import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';

class OnlyOnClient extends (React.Component) {
    componentDidMount() {
        this.setState({
            onServer: false
        });
    }
    render() {
        return this.state.onServer ? this.props.serverContent : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            onServer: true
        };
    }
}
OnlyOnClient.defaultProps = {
    serverContent: /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    })
};

export { OnlyOnClient };
//# sourceMappingURL=OnlyOnClient.js.map
